import '../../ProductSlider/scripts/view';

import { Event } from '../../FilterList/scripts/product-facets';
//import './comparison-view';

( function() {
	'use strict';

	const emit = ( element, eventName, detail = {} ) => {
		element.dispatchEvent( new CustomEvent( eventName, { detail } ) );
	};

	function initProductListView() {
		const productLists = Array.from( document.querySelectorAll( '.product-list-container' ) );

		if ( productLists.length === 0 ) {
			return;
		}

		window.colibri = window.colibri || {};
		window.colibri.card_cache = window.colibri.card_cache || { ready: {}, loading: {}, failed: {}, last_clicked: null };

		const loadProducts = ( maybeLoad, onSuccess, onFailure ) => {
			const toLoad = [];

			Array.from( maybeLoad ).forEach( ( productCode ) => {
				if (
					window.colibri.card_cache.ready[ productCode ] ||
					window.colibri.card_cache.loading[ productCode ] ||
					window.colibri.card_cache.failed[ productCode ]
				) {
					return;
				}
				toLoad.push( productCode );
				window.colibri.card_cache.loading[ productCode ] = true;
			} );

			if ( !toLoad.length ) {
				return;
			}

			const states = Object.keys( window.colibri?.index?.facets?.state_code ?? {} );
			const url = `${window.location.protocol}//${window.location.host}/?cg-ajax-content=partial-grid${states.length === 1 ? `&state=${states[ 0 ]}` : ''}`;

			fetch( url, {
				method: 'POST',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
				body: new URLSearchParams( {
					product_codes: JSON.stringify( toLoad ),
				} ),
			} )
				.then( ( response ) => {
					if ( !response.ok ) {
						throw response;
					}
					return response.text();
				} )
				.then( ( html ) => {
					toLoad.forEach( ( productCode ) => {
						delete window.colibri.card_cache.loading[ productCode ];
						delete window.colibri.card_cache.failed[ productCode ];
						window.colibri.card_cache.ready[ productCode ] = true;
					} );
					if ( typeof onSuccess === 'function' ) {
						onSuccess( html );
					}
				} )
				.catch( ( error ) => {
					toLoad.forEach( ( productCode ) => {
						delete window.colibri.card_cache.loading[ productCode ];
						delete window.colibri.card_cache.ready[ productCode ];
						window.colibri.card_cache.failed[ productCode ] = true;
					} );
					if ( typeof onFailure === 'function' ) {
						onFailure( error );
					}
				} );
		};

		const maybeUpdateCards = ( productList ) => {
			const toLoad = Array.from( productList.querySelectorAll( '.card--placeholder' ) )
				.map( ( card ) => card.getAttribute( 'data-product-code' ) )
				.filter( Boolean );

			if ( toLoad.length === 0 ) {
				return;
			}

			loadProducts(
				toLoad,
				( response ) => {
					const parser = new DOMParser();
					const doc = parser.parseFromString( response, 'text/html' );
					const containers = doc.querySelectorAll( '.product-list-container:not(.is-empty)' );

					containers.forEach( ( container ) => {
						container.querySelectorAll( '.card[id]' ).forEach( ( card ) => {
							const existing = productList.querySelector( `#${card.id}` );
							if ( existing ) {
								existing.replaceWith( card );
							}
						} );
						productList.classList.remove( 'is-empty' );
					} );

					emit( window, 'ColibriEvent:INIT_ALL_ADD_TO_CARTS', { container: productList } );
					const listingContainer = productList.closest( '.listing-container' );
					if ( listingContainer ) {
						emit( listingContainer, Event.UPDATE_TIMEZONES );
						emit( listingContainer, Event.REQUEST_REINDEX );
					}
				},
				( error ) => {
					console.error( 'failure', error );
				}
			);
		};

		const toggleShowAll = ( showAll, productList ) => {
			const isExpanded = showAll.classList.contains( 'is-expanded' );
			if ( isExpanded ) {
				showAll.classList.remove( 'is-expanded' );
			} else {
				showAll.dataset.caption = showAll.textContent;
				showAll.classList.add( 'is-expanded' );
			}

			showAll.textContent = showAll.classList.contains( 'is-expanded' )
				? 'Show Less'
				: ( showAll.dataset.caption || 'Show All' );

			productList.classList.toggle( 'is-collapsed' );
			maybeUpdateCards( productList );
		};

		const updateProductList = ( data, showAll, productList ) => {
			let countMatches = 0;
			const { countFilters, matchingProductsSet } = data;

			productList.querySelectorAll( '.card' ).forEach( ( card ) => {
				const id = Number( card.getAttribute( 'data-item-id' ) );
				const target = card.parentElement?.classList.contains( 'grid-col' ) ? card.parentElement : card;

				if ( !matchingProductsSet.size ) {
					target.classList.add( 'd-none' );
					return;
				}

				if ( !countFilters || matchingProductsSet.has( id ) ) {
					countMatches++;
					target.classList.remove( 'd-none' );
					target.classList.toggle( 'hide-when-collapsed', countMatches > 24 );
					return;
				}

				target.classList.add( 'd-none' );
			} );

			if ( !countMatches ) {
				productList.classList.add( 'is-empty' );
			} else {
				productList.classList.remove( 'is-empty' );
				if ( showAll ) {
					if ( countMatches >= 24 ) {
						showAll.innerHTML = showAll.classList.contains( 'is-expanded' )
							? 'Show Less'
							: `Show All (${ countMatches })`;
						showAll.style.display = '';
					} else {
						showAll.style.display = 'none';
					}
				}
			}

			const itemsLabel = ( countMatches % 10 === 1 ) ? 'item' : 'items';
			const message = countMatches
				? `Found <span>${ countMatches }</span> ${ itemsLabel }`
				: 'No items match the current filtering criteria.';
			const counter = productList.querySelector( '.count-results' );
			if ( counter ) {
				counter.innerHTML = message;
			}

			maybeUpdateCards( productList );
		};

		productLists.forEach( ( productList ) => {
			const showAll = productList.querySelector( '.js-show-all' );

			showAll?.addEventListener( 'click', ( event ) => {
				event.preventDefault();
				toggleShowAll( showAll, productList );
			} );

			productList.addEventListener( Event.LIST_UPDATE, ( event ) => {
				updateProductList( event.detail || {}, showAll, productList );
			} );
		} );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', initProductListView, { once: true } );
	} else {
		initProductListView();
	}
} )();

